<template>
  <v-row>
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loadingDiv"
          indeterminate
        />
      </div>
      <!-- list filters -->
      <v-card>
        <v-card-title> Filtrar </v-card-title>
        <v-row class="px-2 ma-0">
          <v-col
            cols="12"
            sm="4"
          >
            <VSelect
              v-model="filasSelecionadas"
              :items="filas"
              item-text="nome"
              item-value="id"
              label="Fila"
              chips
              multiple
              outlined
              dense
              clearable
              hide-details
              @change="search = false"
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="4"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Período de:"
                  outlined
                  dense
                  clearable
                  color="primary"
                  hide-details
                  v-bind="attrs"
                  :rules="[validators.required]"
                  v-on="on"
                  @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                />
              </template>

              <v-date-picker
                v-model="filtroPeriodoInicio"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu1 = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormatted"
                  label="Período até:"
                  outlined
                  dense
                  clearable
                  hide-details
                  color="primary"
                  v-bind="attrs"
                  :rules="[validators.required]"
                  v-on="on"
                  @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                />
              </template>

              <v-date-picker
                v-model="filtroPeriodoFim"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu2 = false"
              />
            </v-menu>
          </v-col>

          <v-spacer></v-spacer>

          <v-col
            cols="12"
            md="2"
            sm="12"
            class="text-right"
          >
            <v-btn
              color="primary"
              :loading="loadingButton"
              @click="filtrar"
            >
              <span>Filtrar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col
      v-if="filasParametro.length > 0 && search"
      cols="12"
      md="12"
    >
      <tickets-categoria-status-contador
        :dados-tickets-categoria-status="contadorTicketsCategoriaStatus"
        @erro-filtrar="filtrar()"
      />
    </v-col>

    <v-col
      v-if="filasParametro.length === 1 && search"
      cols="12"
      md="12"
    >
      <tickets-status-personalizado
        :dados-tickets-status-personalizado="contadorTicketsStatus"
      />
    </v-col>

    <v-col
      v-if="filasSelecionadas.length === 1 && search"
      cols="12"
      md="12"
    >
      <total-tickets-por-canal
        :dados-tickets="totalTicketsPorCanal"
        :loading.sync="loadingComponentes"
      />
    </v-col>

    <v-col
      v-if="filasParametro.length > 0 && search"
      cols="12"
      md="12"
    >
      <table-total-tickets-fila-categoria-status
        :dados-tickets="totalTicketsPorFila"
        :loading.sync="loadingComponentes"
      />
    </v-col>

    <v-col
      v-if="filasParametro.length > 0 && search"
      cols="12"
      md="12"
    >
      <total-agentes-por-fila
        :dados-tickets="totalAgentesPorFila"
      />
    </v-col>

    <v-col
      v-if="filasSelecionadas.length === 1"
      cols="12"
      md="12"
    >
      <v-row class="match-height">
        <v-col
          v-if="filasParametro.length > 0 && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>

          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="mediaTicketsAgentesOptions.color"
            :icon="mediaTicketsAgentesOptions.icon"
            :statistics="mediaTicketsAgentesTotal.toString()"
            :stat-title="mediaTicketsAgentesOptions.statTitle"
          />
        </v-col>

        <v-col
          v-if="filasParametro.length > 0 && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>

          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="capacidadeAtendimentoOptions.color"
            :icon="capacidadeAtendimentoOptions.icon"
            :statistics="capacidadeAtendimento.toString()"
            :stat-title="capacidadeAtendimentoOptions.statTitle"
          />
        </v-col>

        <v-col
          v-if="filasParametro.length > 0 && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>

          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="mediaEsperaOptions.color"
            :icon="mediaEsperaOptions.icon"
            :statistics="mediaEspera"
            :stat-title="mediaEsperaOptions.statTitle"
          />
        </v-col>
      </v-row>
    </v-col>

    <!-- <v-col
      v-if="filasParametro.length > 0 && search"
      cols="12"
      md="4"
    >
      <total-agentes-por-fila
        :dados-tickets="totalAgentesPorFila"
        :loading.sync="loadingComponentes"
      ></total-agentes-por-fila>
    </v-col> -->
  </v-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiCalendar, mdiPoll } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import { mapState } from 'pinia'
import TicketsCategoriaStatusContador from '@/views/dashboard/TicketsCategoriaStatusContador.vue'
import TicketsStatusPersonalizado from '@/views/dashboard/TicketsStatusPersonalizado.vue'
import TotalTicketsPorCanal from '@/views/dashboard/TotalTicketsPorCanal.vue'
import TableTotalTicketsFilaCategoriaStatus from '@/components/tables/TableTotalTicketsFilaCategoriaStatus.vue'
import StatisticsCardVertical from '@/@core/components/statistics-card/StatisticsCardVertical.vue'
import TotalAgentesPorFila from '@/views/dashboard/TotalAgentesPorFila.vue'
import useUserStore from '@/store/user'
import { formatTime } from '@/utils/time'
import FilaService from '@/services/modules/FilaService'
import DashboardService from '@/services/modules/DashboardService'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    TicketsCategoriaStatusContador,
    TicketsStatusPersonalizado,
    TableTotalTicketsFilaCategoriaStatus,
    StatisticsCardVertical,
    TotalTicketsPorCanal,
    TotalAgentesPorFila,
  },

  data: () => ({
    filas: [],
    filasSelecionadas: [],
    filasParametro: [],
    loadingDiv: true,
    loadingButton: false,
    loadingComponentes: false,
    search: false,
    mediaTicketsAgentesTotal: ref(0),
    capacidadeAtendimento: ref(0),
    contadorTicketsCategoriaStatus: [],
    contadorTicketsStatus: [],
    totalTicketsPorCanal: [],
    totalAgentesPorFila: [],
    totalTicketsPorFila: [],
    mediaEspera: '',
  }),

  computed: {
    ...mapState(useUserStore, ['id', 'isUsuario']),
  },

  mounted() {
    this.getFilas()
  },

  methods: {
    async getFilas() {
      try {
        this.filas = await FilaService.get(100, null, 2, this.id)
        this.loadingDiv = false
      } catch {
        this.loadingDiv = false
      }
    },

    async filtrar() {
      this.loadingButton = true
      this.filasParametro = this.filasSelecionadas.length > 0 ? this.filasSelecionadas : this.filas.map(it => it.id)

      if (Date.parse(this.filtroPeriodoFim) < Date.parse(this.filtroPeriodoInicio)) {
        this.$toast.warning('O periódo final deve ser maior que o periódo inicial!', {
          timeout: false,
        })
        this.loadingButton = false

        return
      }

      const diferenca = Date.parse(this.filtroPeriodoFim) - Date.parse(this.filtroPeriodoInicio)
      const diferencaDias = diferenca / (1000 * 3600 * 24)
      if (diferencaDias >= 366) {
        this.$toast.warning('A diferença entre as datas deve ser de no máximo 365 dias!', {
          timeout: false,
        })
        this.loadingButton = false

        return
      }

      this.search = true

      this.loadingComponentes = true
      if (this.filasParametro.length > 0) {
        await this.getMediaTicketsPorAgentes()
        await this.getCapacidadeAtendimento()
        await this.getMediaEspera()
        await this.getTotalTicketsCategoriaStatus()
        await this.getTotalAgentesPorFila()
        await this.getTotalTicketsFilasPorCategoriaStatus()
      }
      if (this.filasSelecionadas.length === 1) {
        await this.getTotalTicketsStatus()
        await this.getTotalTicketsCanal()
      }
      this.loadingComponentes = false
      this.loadingButton = false
    },

    async getMediaTicketsPorAgentes() {
      this.mediaTicketsAgentesTotal = await DashboardService.getFilaMediaTicketsAgentes(this.filasParametro, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getCapacidadeAtendimento() {
      this.capacidadeAtendimento = await DashboardService.getFilaCapacidadeAtendimento(this.filasParametro)
    },

    async getMediaEspera() {
      if (this.filasSelecionadas.length > 1) return
      const total = await DashboardService.getFilaMediaEspera(this.filasParametro, this.filtroPeriodoInicio, this.filtroPeriodoFim)
      this.mediaEspera = total ? formatTime(total) : '0 horas'
    },

    async getTotalTicketsCategoriaStatus() {
      this.contadorTicketsCategoriaStatus = await DashboardService.getFilaTotalTicketsCategoriaStatus(this.filasParametro, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getTotalTicketsStatus() {
      this.contadorTicketsStatus = await DashboardService.getFilaTotalTicketsStatus(this.filasSelecionadas[0], this.filtroPeriodoInicio, this.filtroPeriodoFim, true)
    },

    async getTotalTicketsCanal() {
      this.totalTicketsPorCanal = await DashboardService.getFilaTotalTicketsFilaCanal(this.filasSelecionadas[0], this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getTotalAgentesPorFila() {
      this.totalAgentesPorFila = await DashboardService.getFilaTotalAgentes(this.filasParametro)
    },

    async getTotalTicketsFilasPorCategoriaStatus() {
      this.totalTicketsPorFila = await DashboardService.getFilaTicketsCategoriaStatus(this.filasParametro, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },
  },

  setup() {
    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())
    const menu1 = ref(false)
    const menu2 = ref(false)

    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}/${month}/${year}`
    }

    const parseDate = dates => {
      if (!dates) return null
      const [day, month, year] = dates.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    const mediaTicketsAgentesOptions = {
      statTitle: 'Média tickets por agentes',
      icon: mdiPoll,
      color: 'secondary',
    }

    const capacidadeAtendimentoOptions = {
      statTitle: 'Capacidade atendimento',
      icon: mdiPoll,
      color: 'secondary',
    }

    const mediaEsperaOptions = {
      statTitle: 'Média de espera',
      icon: mdiPoll,
      color: 'secondary',
    }

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    return {
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      mediaTicketsAgentesOptions,
      capacidadeAtendimentoOptions,
      mediaEsperaOptions,
      parseDate,
      formatDate,

      // icons
      icons: {
        mdiCalendar,
      },

      // validation
      validators: {
        required,
        select,
      },
    }
  },

}
</script>
